module.exports = __webpack_public_path__ + "static/media/file.29a3016e.svg";